const FETCH_INVOICE_CHANGES = 'fetch_invoiceChanges';
const FETCH_INVOICE_CHANGE = 'fetch_invoiceChange';
const DELETE_INVOICE_CHANGE = 'delete_invoiceChange';
const PERSIST_INVOICE_CHANGE = 'persist_invoiceChange';
export default {
    FETCH_INVOICE_CHANGES,
    FETCH_INVOICE_CHANGE,
    DELETE_INVOICE_CHANGE,
    PERSIST_INVOICE_CHANGE,
};
